import axios from '@/plugins/http/axios.js';
import config from "@/views/reports/config/reports.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);

export const service = {

    getListReports : (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/report`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
    
    getListStartMonetizations: (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report/monetization/data`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getListConfirmMonetizations: (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getEmailSend: (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/report/user/email`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    generateMonetizationReport: (idGroup,idEmpresa, idUsuario, isDownload) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report/create/report/?isDownload=${isDownload}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    postConfirmMonetizations: (idGroup,idEmpresa, idUsuario, document ) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/monetization-report/confirm`,
            headers:{
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario 
            },
            data: document,
            redirect: 'follow'
        })
    },

    postHistoricMonetization: (idGroup, idEmpresa, idUsuario, data ) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/monetization-report/history`,
            headers:{
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario 
            },
            data: data,
            redirect: 'follow'
        })
    },

    getMonetizationReportJobStatus: (idGroup, idEmpresa, idUsuario, jobId) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report/job/${jobId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getConfirmMonetizationJobStatus: (idGroup, idEmpresa, idUsuario, jobId) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report/confirm/job/${jobId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getHistoryMonetizationJobStatus: (idGroup, idEmpresa, idUsuario, jobId) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report/history/job/${jobId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    generateStarsBalanceReport: (idGroup, idEmpresa, idUsuario, userId) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/affiliates-report/stars-balance?userId=${userId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    generateAffiliatesPeriodReport: (idGroup, idEmpresa, idUsuario, startDate, endDate, companyId) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/affiliates-report/affiliates-in-period?startDate=${startDate}&endDate=${endDate}&companyId=${companyId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    sendAffiliatesPeriodReportEmail: (idGroup, idEmpresa, idUsuario, startDate, endDate, companyId) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/affiliates-report/affiliates-in-period/send?startDate=${startDate}&endDate=${endDate}&companyId=${companyId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    generateAffiliatesBotStarsReport: (idGroup, idEmpresa, idUsuario, startDate, endDate) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/affiliates-report/with-bot-stars?startDate=${startDate}&endDate=${endDate}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    sendAffiliatesBotStarsReportEmail: (idGroup, idEmpresa, idUsuario, startDate, endDate) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/affiliates-report/with-bot-stars/send?startDate=${startDate}&endDate=${endDate}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    postHistoricAssignmentDownloadReportZen: (idGroup, idEmpresa, idUsuario, data ) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/shape-report/zen-star/generate/report`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario 
            },
            data: data,
            redirect: 'follow'
        })
    },

    postHistoricAssignmentSendReportZen: (idGroup, idEmpresa, idUsuario, data ) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/shape-report/zen-star/send/report`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario 
            },
            data: data,
            redirect: 'follow'
        })
    },

    postHistoricAssignmentDownloadReportValue: (idGroup, idEmpresa, idUsuario, data ) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/value-star-report/generate/report`,
            headers:{
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario 
            },
            data: data,
            redirect: 'follow'
        })
    },

    postHistoricAssignmentSendReportValue: (idGroup, idEmpresa, idUsuario, data ) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/value-star-report/send/report`,
            headers:{
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario 
            },
            data: data,
            redirect: 'follow'
        })
    },

    generateStarTaxReport: (idGroup, idEmpresa, idUsuario, year, month) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/star-tax-report/create/report?year=${year}&month=${month}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getStarTaxReportJobStatus: (idGroup, idEmpresa, idUsuario, jobId) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/star-tax-report/job/${jobId}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
};
